<template>
  <header class="app-header">
    <div class="logo">
      <slot name="header-left"></slot>
    </div>
    <div class="header-right">
      <slot name="header-right"></slot>
    </div>
  </header>
  <slot name="filters"></slot>
  <div class="content-wrapper">
    <nav class="sidebar">
      <slot name="sidebar"></slot>
    </nav>
    <main class="content">
      <slot name="main"></slot>
    </main>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Layout',
});
</script>
